// @avantia common-code
import { HpPrerequisiteThisReference } from '@avantia/questionset-script-parser';
import { HpQuestionIds } from './types/questionConstants';

export interface AddressDataBeforeEditModel {
  deleteIsCancel: boolean;
  showCancel: boolean;
  showDelete: boolean;
  isCurrentAddress?: boolean;
  movedInDate?: string;
  movedOutDate?: string;
  propertyNameNumber?: string;
  addressEnterManuallyButton?: string;
  addressLine1?: string;
  addressLine2?: string;
  townCity?: string;
  county?: string;
  postcode?: string;
  addressLookupButton?: string;
  addressLookupResults?: string;
  addressId?: string;
  addressLookupJson?: string;
  // isCountryUk?: string;
}

export interface HpAddressDetailsItemIds {
  isCurrentAddressName: keyof HpQuestionIds;
  movedInDateName: keyof HpQuestionIds;
  movedOutDateName: keyof HpQuestionIds;
  addressEnterManuallyButtonName: keyof HpQuestionIds;
  propertyNameNumberName: keyof HpQuestionIds;
  addressLine1Name: keyof HpQuestionIds;
  addressLine2Name: keyof HpQuestionIds;
  townCityName: keyof HpQuestionIds;
  countyName: keyof HpQuestionIds;
  // isCountryUkName: keyof HpQuestionIds;
  // countryName: keyof HpQuestionIds;
  postcodeName: keyof HpQuestionIds;
  addressLookupButtonName: keyof HpQuestionIds;
  addressLookupResultsName: keyof HpQuestionIds;
  addressIdName: keyof HpQuestionIds;
  addressLookupJsonName: keyof HpQuestionIds;
}

type HpCreateDataEditAnswerProps = HpAddressDetailsItemIds;

export type HpAddressItemTypes = 'address';

export interface CreateAddressDataBeforeEditProps {
  action: 'save' | 'edit';
  name: HpAddressItemTypes;
  self: HpPrerequisiteThisReference;
}

export const addressItemIds = createIdMapFunction();

export function createDataForAddress({
  action,
  name,
  self
}: CreateAddressDataBeforeEditProps): AddressDataBeforeEditModel {
  const {
    isCurrentAddressName,
    movedInDateName,
    movedOutDateName,
    addressEnterManuallyButtonName,
    propertyNameNumberName,
    addressLine1Name,
    addressLine2Name,
    townCityName,
    countyName,
    // countryName,
    // isCountryUkName,
    postcodeName,
    addressLookupButtonName,
    addressLookupResultsName,
    addressIdName,
    addressLookupJsonName
  } = addressItemIds[name];
  const isCurrentAddress = self.getAnswerValue(isCurrentAddressName);
  const movedInDate = self.getAnswerValue(movedInDateName);
  const movedOutDate = self.getAnswerValue(movedOutDateName);
  const addressEnterManuallyButton = self.getAnswerValue(addressEnterManuallyButtonName);
  const propertyNameNumber = self.getAnswerValue(propertyNameNumberName);
  const addressLine1 = self.getAnswerValue(addressLine1Name);
  const addressLine2 = self.getAnswerValue(addressLine2Name);
  const townCity = self.getAnswerValue(townCityName);
  const postcode = self.getAnswerValue(postcodeName);
  const county = self.getAnswerValue(countyName);
  // const country = self.getAnswerValue(countryName);
  const addressLookupButton = self.getAnswerValue(addressLookupButtonName);
  const addressLookupResults = self.getAnswerValue(addressLookupResultsName);
  const addressId = self.getAnswerValue(addressIdName);
  const addressLookupJson = self.getAnswerValue(addressLookupJsonName);
  // const isCountryUk = self.getAnswerValue(isCountryUkName);
  let map: AddressDataBeforeEditModel;
  if (action === 'edit') {
    const tmp: AddressDataBeforeEditModel = {
      deleteIsCancel: false,
      showCancel: true,
      showDelete: true
    };

    tmp.isCurrentAddress = isCurrentAddress;
    tmp.movedInDate = movedInDate;
    tmp.movedOutDate = movedOutDate;
    tmp.addressEnterManuallyButton = addressEnterManuallyButton;
    tmp.propertyNameNumber = propertyNameNumber;
    tmp.addressLine1 = addressLine1;
    tmp.addressLine2 = addressLine2;
    tmp.townCity = townCity;
    // tmp.county = country;
    tmp.county = county;
    tmp.postcode = postcode;
    tmp.addressLookupButton = addressLookupButton;
    tmp.addressLookupResults = addressLookupResults;
    tmp.addressId = addressId;
    tmp.addressLookupJson = addressLookupJson;
    // tmp.isCountryUk = isCountryUk;

    map = tmp;
  } else {
    map = { showCancel: true, showDelete: true, deleteIsCancel: false };
  }

  return map;
}

function createIdMapFunction(): { [key: string]: HpAddressDetailsItemIds } {
  const address: HpCreateDataEditAnswerProps = {
    isCurrentAddressName: 'isCurrentAddress',
    // countryName: 'country',
    movedInDateName: 'movedInDate',
    movedOutDateName: 'movedOutDate',
    addressEnterManuallyButtonName: 'addressEnterManuallyButton',
    propertyNameNumberName: 'propertyNameNumber',
    addressLine1Name: 'addressLine1',
    addressLine2Name: 'addressLine2',
    townCityName: 'townCity',
    countyName: 'county',
    postcodeName: 'postcode',
    addressLookupButtonName: 'addressLookupButton',
    addressLookupResultsName: 'addressLookupResults',
    addressIdName: 'addressId',
    addressLookupJsonName: 'addressLookupJson'
    // isCountryUkName: 'isCountryUk'
  };

  return { address };
}
